import { useEffect, useState } from 'react'
import { userAPI, type Markedsomrade } from '../services/api'
import i18n from '../i18n'
import { localizeApiDetail } from '../i18n/apiError'

export function useMineMarkedsomrader() {
  const [items, setItems] = useState<Markedsomrade[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refresh = async () => {
    try {
      setLoading(true)
      const res = await userAPI.getMineMarkedsomrader()
      setItems(res.data?.items ?? [])
      setError(null)
    } catch (err: any) {
      setError(localizeApiDetail(err?.response?.data?.detail) || err?.message || i18n.t('errors.loadMarkedsomrader'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    refresh()
  }, [])

  return { items, loading, error, refresh }
}
